<template>
  <div class="staff">
    <div class="top">
      <span style="font-size: 18px; font-weight: 400; color: #333">
        文章图库
      </span>
      <el-divider></el-divider>

	  <div class="form">
		<el-button type="primary" @click="showUpload = true">上传图片</el-button>
		<el-button type="primary"  @click="showAddGroup = true">新增图片组</el-button>
		<el-button type="primary"  @click="showEditGroup = true">编辑图片组</el-button>
		<el-button type="danger" @click="deleteImages">批量删除</el-button>
	  </div>

      <el-select v-model="FileGroupId" filterable style="margin:20px 0 0;" placeholder="选择图片组" @change="getPageList">
        <el-option v-for="g in groupList" :key="g.Id" :label="g.GroupName" :value="g.Id"/>
	  </el-select>
    </div>

	<el-tabs v-model="FileGroupId" type="card" @tab-click="getPageList" style="margin-top:20px;">
		<el-tab-pane v-for="item in groupList" :label="item.GroupName" :name="item.Id">
		</el-tab-pane>
	</el-tabs>

    <!-- 图片列表 -->
	<div style="display: flex;justify-content: flex-start;align-items: flex-start;flex-wrap: wrap">
			<div class="block" v-for="item in ImageList" :key="item.FileId"
				style="position: relative;margin-right:20px">
				<el-checkbox v-model="item.checked" style="position: absolute; right:0; top:0"></el-checkbox>
				<el-image style="width: 100px; height: 100px;" :src="item.RemoteUrl" fit="fill">
				</el-image>
			</div>
		</div>
    <!-- <div class="image-list">
      <div class="image-item" v-for="img in ImageList" :key="img.FileId">
        <el-checkbox v-model="img.checked" />
        <el-image
          :src="img.RemoteUrl"
          fit="cover"
          style="width: 100px; height: 100px"
        />
      </div>
    </div> -->

    <!-- 分页 -->
    <el-pagination
      background
      layout="total, prev, pager, next, sizes, jumper"
      :total="total"
      :page-size="page.PageSize"
      :current-page="page.PageIndex"
      @current-change="changePage"
      @size-change="changeSize"
    />

    <!-- 上传弹窗 -->
    <el-dialog
      title="上传图片"
      :visible.sync="showUpload"
      width="40%"
      destroy-on-close
    >
      <add-or-edit
        :options="groupList"
        @success="uploadSuccess"
        @close="showUpload = false"
      />
    </el-dialog>

    <!-- 新增分组 -->
    <el-dialog title="新增图片组" :visible.sync="showAddGroup" width="25%">
      <div style="margin-bottom:10px; font-weight:500;">新增图片组</div>
      <el-input v-model="newGroupName" placeholder="分组名称" />
      <div class="dialog-footer" style="text-align: right; margin-top: 12px;">
        <el-button type="primary" @click="addGroup" >确定</el-button>
        <el-button @click="showAddGroup = false" style="margin-left:8px;">取消</el-button>
      </div>
    </el-dialog>

    <!-- 编辑分组 -->
    <el-dialog title="编辑图片组" :visible.sync="showEditGroup" width="30%">
      <div>选择图片组</div>
      <el-select v-model="editGroupId" placeholder="选择分组">
        <el-option
          v-for="g in groupList"
          :key="g.Id"
          :label="g.GroupName"
          :value="g.Id"
        />
      </el-select>
      <div style="margin-top:10px">编辑图片组名称</div>
      <el-input v-model="editGroupName" style="margin-top: 10px" />
      <div class="dialog-footer" style="text-align: right; margin-top: 12px;">
        <el-button type="danger" @click="deleteGroup">删除</el-button>
        <el-button type="primary" @click="updateGroup" style="margin-left:8px">确定</el-button>
        <el-button @click="showEditGroup = false" style="margin-left:8px">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import addOrEdit from "./edit.vue";

export default {
  components: { addOrEdit },
  data() {
    return {
      groupList: [],
      ImageList: [],
      FileGroupId: "",
      total: 0,
      page: {
        PageIndex: 1,
        PageSize: 20,
      },

      showUpload: false,
      showAddGroup: false,
      showEditGroup: false,

      newGroupName: "",
      editGroupId: "",
      editGroupName: "",
    };
  },
  created() {
    this.getGroups();
  },
  methods: {
    // 获取分组
    getGroups() {
      this.$get(this.$api.GetFileGroup, {
        businessType: "ArticleImage",
      }).then((res) => {
        this.groupList = res.Data;
        this.FileGroupId = res.Data[0]?.Id;
        this.getPageList();
      });
    },

    // 获取图片
    getPageList() {
      this.$get(this.$api.GetFilesFromGroup, {
        FileGroupId: this.FileGroupId,
        ...this.page,
      }).then((res) => {
        this.ImageList = res.Data.map((i) => ({
          ...i,
          checked: false,
        }));
        this.total = res.TotalNumber;
      });
    },

    deleteImages() {
      const ids = this.ImageList.filter((i) => i.checked).map((i) => i.FileId);

      if (!ids.length) {
        this.$message.warning("请选择图片");
        return;
      }

      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        distinguishCancelAndClose: true,
        confirmButtonClass: 'el-button--danger',
        cancelButtonClass: '',
        center: true
      }).then(() => {
        this.$post(this.$api.DelFilesFromGroup, {
          FileIds: ids,
          FileGroupId: this.FileGroupId,
        }).then(() => {
          this.$message.success("删除成功");
          this.getPageList();
        });
      }).catch(() => {
        // 用户取消，无需处理
      });
    },

    addGroup() {
      this.$post(this.$api.AddFileGroup, {
        GroupName: this.newGroupName,
      }).then(() => {
        this.showAddGroup = false;
        this.getGroups();
      });
    },

    updateGroup() {
      this.$post(this.$api.UpdateFileGroup, {
        Id: this.editGroupId,
        GroupName: this.editGroupName,
      }).then(() => {
        this.showEditGroup = false;
        this.getGroups();
      });
    },

    deleteGroup() {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        distinguishCancelAndClose: true,
        confirmButtonClass: 'el-button--danger',
        cancelButtonClass: '',
        center: true
      }).then(() => {
        this.$post(
          this.$api.DeleteFileGroup + "?id=" + this.editGroupId,
          {}
        ).then(() => {
          this.showEditGroup = false;
          this.getGroups();
        });
      }).catch(() => {
        // 用户取消，无需处理
      });
    },

    changePage(p) {
      this.page.PageIndex = p;
      this.getPageList();
    },
    changeSize(s) {
      this.page.PageSize = s;
      this.getPageList();
    },

    uploadSuccess() {
      this.showUpload = false;
      this.getPageList();
    },
  },
};
</script>


<style lang="stylus" scoped>
.staff {
  background: #fff;
  padding: 10px 10px;
  border-radius: 10px;
  .el-form-item{
    margin-right:30px
  }
  .backSpan {
    padding: 0px 10px;
    cursor: pointer;
  }

  .top {
    margin-bottom: 10px;
    .el-divider--horizontal {
      margin: 10px 0;
    }

    button {
      margin-left: 10px;
    }
  }
}

</style>